var map = {
	"./avatar-profile-group.svg": 3518,
	"./card-event-placeholder.jpg": 4897,
	"./card-profile-avatar.svg": 7969,
	"./check.svg": 7909,
	"./chevron--down.svg": 1090,
	"./chevron--up.svg": 3873,
	"./directory-placeholder.png": 1059,
	"./favicons/android-icon-144x144.png": 734,
	"./favicons/android-icon-192x192.png": 1806,
	"./favicons/android-icon-36x36.png": 1512,
	"./favicons/android-icon-48x48.png": 2990,
	"./favicons/android-icon-72x72.png": 6416,
	"./favicons/android-icon-96x96.png": 6308,
	"./favicons/apple-icon-114x114.png": 5453,
	"./favicons/apple-icon-120x120.png": 6453,
	"./favicons/apple-icon-144x144.png": 4169,
	"./favicons/apple-icon-152x152.png": 1665,
	"./favicons/apple-icon-180x180.png": 6737,
	"./favicons/apple-icon-57x57.png": 8049,
	"./favicons/apple-icon-60x60.png": 1285,
	"./favicons/apple-icon-72x72.png": 1823,
	"./favicons/apple-icon-76x76.png": 479,
	"./favicons/apple-icon-precomposed.png": 7794,
	"./favicons/apple-icon.png": 866,
	"./favicons/apple-touch-icon.png": 1556,
	"./favicons/favicon-16x16.png": 7499,
	"./favicons/favicon-32x32.ico": 562,
	"./favicons/favicon-32x32.png": 8547,
	"./favicons/favicon-48x48.png": 3421,
	"./favicons/favicon-96x96.png": 9755,
	"./favicons/favicon.ico": 8724,
	"./favicons/favicon.svg": 7105,
	"./favicons/ms-icon-144x144.png": 1907,
	"./favicons/ms-icon-150x150.png": 9343,
	"./favicons/ms-icon-310x310.png": 1219,
	"./favicons/ms-icon-70x70.png": 69,
	"./favicons/web-app-manifest-192x192.png": 4733,
	"./favicons/web-app-manifest-512x512.png": 9421,
	"./loading.gif": 5337,
	"./logo-canton-vaud.svg": 7823,
	"./logo-hes-so.svg": 6816,
	"./logo-hesav.jpg": 2187,
	"./logo-hesav.svg": 676,
	"./placeholder/alpha-team-alpha.jpg": 6323,
	"./placeholder/card-article.jpg": 77,
	"./placeholder/card-image--physiotherapie.jpg": 2142,
	"./placeholder/card-image--recherche.jpg": 2155,
	"./placeholder/card-image--sage-femme.jpg": 999,
	"./placeholder/card-image--soins-infirmiers.jpg": 5951,
	"./placeholder/card-image--trm.jpg": 2311,
	"./placeholder/card-project.jpg": 7016,
	"./placeholder/directory-profile.jpg": 1713,
	"./placeholder/header-home.jpg": 3633,
	"./placeholder/header-rich.jpg": 1282,
	"./placeholder/image-portrait-251x300.jpg": 2735,
	"./placeholder/image-portrait.jpg": 8947,
	"./placeholder/image-rich-content-1024x576.jpg": 4048,
	"./placeholder/image-rich-content-300x169.jpg": 2114,
	"./placeholder/image-rich-content-768x432.jpg": 3025,
	"./placeholder/image-rich-content.jpg": 8780,
	"./placeholder/infographie-bachelor.svg": 5620,
	"./placeholder/infographie-equipe.svg": 2843,
	"./placeholder/infographie-etudiants.svg": 7125,
	"./placeholder/infographie-publication.svg": 5172,
	"./placeholder/infographie-recherche.svg": 5753,
	"./placeholder/infographie-stage.svg": 2368,
	"./placeholder/minisite/header-cover.jpg": 1822,
	"./placeholder/minisite/header-home.jpg": 6842,
	"./placeholder/next-300x169.jpg": 8243,
	"./placeholder/next-768x432.jpg": 9768,
	"./placeholder/next.jpg": 6773,
	"./placeholder/section-description--right.jpg": 7598,
	"./placeholder/section-description.jpg": 6848,
	"./placeholder/video-thumbnail.jpg": 9030,
	"./video-play.png": 612,
	"./vimeo-play.png": 6555,
	"./youtube-play.png": 1666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5584;